var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNationalMembership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1D1D22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.667)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 8.333,
    cy: 15.833,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 8.333,
    cy: 18.333,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333.625a2.7 2.7 0 0 1 1.915.793 2.7 2.7 0 0 1 .794 1.915v9.63c0 .936-.483 1.805-1.278 2.3l-5.88 3.658a1.04 1.04 0 0 1-1.101 0l-5.88-3.659a2.708 2.708 0 0 1-1.278-2.299v-9.63a2.7 2.7 0 0 1 .793-1.915A2.7 2.7 0 0 1 3.333.625z",
    stroke: "currentColor",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.417 8.75V2.917c0-.23.186-.417.416-.417h3.161c.11 0 .217.044.295.122l.589.59a.417.417 0 0 0 .295.121h2.744c.23 0 .416.187.416.417v5.833c0 .23-.186.417-.416.417h-2.744a.417.417 0 0 1-.295-.122l-.59-.59a.417.417 0 0 0-.294-.121h-3.16a.417.417 0 0 1-.417-.417z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 3.333,
    y: 2.5,
    width: 1.667,
    height: 14.167,
    rx: 0.417
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalMembership);
export default __webpack_public_path__ + "static/media/national-membership.ae7584ec123446e37671720bc6fd7e12.svg";
export { ForwardRef as ReactComponent };